export default __webpack_public_path__ + "static/media/rider.75f5f467.webp";